import React from 'react';

class Banner extends React.Component {
  render() {
    const { image, title, rightAligned } = this.props;
    const titleClasses = rightAligned ? 'banner__title-wrapper banner__title-wrapper--right' : 'banner__title-wrapper';

    return (
      <div className="banner" style={{ backgroundImage: 'url(' + image + ')'}}>
        <div className="banner__overlay"></div>
        <div className="container--wide">
          <div className={titleClasses}>
            <div className="banner__title"><h1>{title}</h1></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/banner/index.js